import React from "react";
import { Button, FormControl } from "@mui/material";

/**
 * Renders a button field inside EnhancedConfirmationDialog form
 *
 * @param {Object} props
 * @param {Object} props.field - Field configuration
 * @param {string} props.field.name - Unique name
 * @param {string} props.field.text - Button text
 * @param {Function} props.field.onClick - Click handler
 * @param {string} props.field.variant - MUI variant (contained/outlined/text)
 * @param {string} props.field.color - MUI color (primary/secondary/error/...)
 * @param {boolean} props.field.fullWidth - Button full width
 * @param {boolean} props.field.disabled - Disabled state
 * @param {Object} props.field.sx - Optional sx styling
 */
const ButtonFieldRenderer = ({ field }) => {
    const {
        text = "Button",
        onClick,
        variant = "contained",
        color = "primary",
        fullWidth = false,
        disabled = false,
        sx,
    } = field;

    return (
        <FormControl fullWidth={fullWidth} disabled={disabled}>
            <Button
                type="button"
                variant={variant}
                color={color}
                fullWidth={fullWidth}
                disabled={disabled}
                onClick={onClick}
                sx={sx}
            >
                {text}
            </Button>
        </FormControl>
    );
};

export default ButtonFieldRenderer;
